import { useGraphQLQuery } from '@betterment/graphql';

import { DeferralSettingsQueryResult } from './data';
import { DeferralSettingsDocument } from './graphql/query.deferralSettings.generated';

export const useDeferralSettingsQuery = (): DeferralSettingsQueryResult => {
  const { data } = useGraphQLQuery(DeferralSettingsDocument, { throwOnError: true });

  const isLoading = !data;

  return {
    isLoading,
    deferralSettings: data?.deferralSettings,
  };
};
